export const UI = 'ui'
export const API = 'api'
